import tabEn from './tab/en.json';
import tabZhHant from './tab/zh-Hant.json';
import tabVi from './tab/vi.json';
import tabTh from './tab/th.json';

export default {
  en: tabEn,
  'zh-Hant': tabZhHant,
  vi: tabVi,
  th: tabTh,
};
